import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { Trace } from '../models/Trace';

export class TraceMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Trace {
    return new Trace(this.gqlIdEncoder.decode(data.id), data.name);
  }
}
